/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface MangimificioDTO
 */
export interface MangimificioDTO {
    /**
     * 
     * @type {number}
     * @memberof MangimificioDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MangimificioDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof MangimificioDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the MangimificioDTO interface.
 */
export function instanceOfMangimificioDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MangimificioDTOFromJSON(json: any): MangimificioDTO {
    return MangimificioDTOFromJSONTyped(json, false);
}

export function MangimificioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MangimificioDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function MangimificioDTOToJSON(value?: MangimificioDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

